import Http from 'axios'
import {API_URL, VERSION} from '../../config/config'
import {CLOSE_PRINT_CONTENT, SET_PRINT_CONTENT, SET_PRINT_CONTENT_ONLY,SET_PRINT_TYPE} from "../mutation-type";

function initialState() {
    return {
        content: null,
        dialog: false,
        printType:null
    }
}

const mutations = {
    [SET_PRINT_CONTENT](state, content) {
        state.content = content;
        state.dialog = true;
    },
    [SET_PRINT_TYPE](state, content) {
        state.printType = content;
    },
    [SET_PRINT_CONTENT_ONLY](state, content) {
        state.content = content;
    },
    [CLOSE_PRINT_CONTENT](state) {
        state.dialog = false;
    },
};

export default {
    state: initialState,
    mutations
}
